import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CREATE_CONTENT,
  CREATE_CONTENT_SUCCESS,
} from 'catalog/actions/contents';
import { CHANGE_EDITION_PLATFORM } from 'catalog/actions/platforms';
import * as Api from 'catalog/api/contents';

function* createContent({ page, platform }) {
  const content = yield call(Api.createContent, page.id, platform);

  yield put({
    type: CREATE_CONTENT_SUCCESS,
    content,
  });

  // Don't forget to update current edition platform
  yield put({
    type: CHANGE_EDITION_PLATFORM,
    platform,
  });
}

export default function* root() {
  yield [takeEvery(CREATE_CONTENT, createContent)];
}



// WEBPACK FOOTER //
// ./src/modules/catalog/sagas/contents.js